import { Skeleton } from "@/components/ui/skeleton";
const CategoryLoader = () => <div className="flex items-center space-x-3 w-[300px] h-[30px]" data-sentry-component="CategoryLoader" data-sentry-source-file="category-loader.tsx">
    <Skeleton className="h-[20px] w-[20px] rounded-sm" data-sentry-element="Skeleton" data-sentry-source-file="category-loader.tsx" />
    <Skeleton className="h-[20px] w-[200px] rounded-sm" data-sentry-element="Skeleton" data-sentry-source-file="category-loader.tsx" />
  </div>;
export default CategoryLoader;